import React from 'react';
import { Redirect } from 'react-router-dom';
import Navbar from '../Components/General/Navbar';

export default function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    const token = sessionStorage.getItem('token');

    if (!token) {
      return <Redirect to="/login" />;
    }

    return (
      <Navbar>
        <Component {...props} />
      </Navbar>
    );
  };
}
